<template>
  <div class="lang" :class="{ '-open': showLang }">
    <button
      type="button"
      @click="onClick"
      :aria-expanded="showLang ? 'true' : 'false'"
      aria-controls="menu-lang"
      id="btn-lang"
      class="d-flex align-items-center utils-button"
      :tabindex="isMobile && !menuOpen ? -1 : 0"
    >
      <GlobeIcon />
      <span class="d-md-none ml-4 link-light -reverse">{{ $t(lang) }} - {{ currency }}</span>
    </button>
    <transition name="fade">
      <div
        class="menu_lang container-fluid"
        v-show="showLang"
        role="region"
        aria-labelledby="btn-lang"
        id="menu-lang"
      >
        <div class="row menu_lang-container">
          <button
            class="back d-flex d-md-none align-items-center col-12"
            type="button"
            @click="showLang = false"
          >
            <undo-icon />
            <span class="font-bold ml-4 pl-2 -upper">{{ $t('Choose your Country/Region') }}</span>
          </button>
          <p class="-upper col-12 menu_lang-title d-none d-md-block">
            {{ $t('Choose your Country/Region') }}
          </p>
          <ul class="world col-12" v-bsl="showLang && menuOpen">
            <li class="d-md-flex flex-md-column">
              <button
                type="button"
                aria-controls="lang-america"
                :aria-expanded="world === 1 ? 'true' : 'false'"
                :class="{ '-active': world === 1 }"
                class="link-light d-flex align-items-center justify-content-between d-md-none"
                @click="world = world === 1 ? 0 : 1"
              >
                {{ $t('America') }}
              </button>
              <p class="font-small menu_lang-subtitle -upper">
                {{ $t('America') }}
              </p>
              <ul id="lang-america" class="row menu_lang-list">
                <li
                  class="col-12"
                  v-for="country in ameriques"
                  :key="country.name + country.i18n.defaultLanguage"
                >
                  <div class="menu_lang-element">
                    <ShopIcon
                      :class="{'hidden-icon': !(country.include_in_menu && country.is_e_com)}"
                      class="cart-icon"
                      aria-hidden="true"
                    />
                    <a
                      v-if="country.include_in_menu && country.accessibility"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                    >
                      <span aria-hidden="true">{{ $t(country.name) }}</span>
                      <span class="a11y-sr-only">
                        {{ $t(country.accessibility) }}
                      </span>
                    </a>
                    <a
                      v-else-if="country.include_in_menu"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                      :aria-label="country.name + ' - ' + $t('Ecommerce store')"
                    >
                      {{ $t(country.name) }}
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <li class="d-md-flex flex-md-column">
              <button
                type="button"
                aria-controls="lang-europe"
                :aria-expanded="world === 3 ? 'true' : 'false'"
                :class="{ '-active': world === 3 }"
                class="link-light d-flex align-items-center justify-content-between d-md-none"
                @click="world = world === 3 ? 0 : 3"
              >
                {{ $t('Europe') }}
              </button>
              <p class="font-small menu_lang-subtitle -upper">
                {{ $t('Europe') }}
              </p>
              <ul id="lang-europe" class="row menu_lang-list">
                <li class="col-12 col-md-6 col-lg-4" v-for="country in europe" :key="country.name">
                  <div class="menu_lang-element">
                    <ShopIcon
                      :class="{'hidden-icon': !(country.include_in_menu && country.is_e_com)}"
                      class="cart-icon"
                      aria-hidden="true"
                    />
                    <a
                      v-if="country.include_in_menu && country.accessibility"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                    >
                      <span aria-hidden="true">{{ $t(country.name) }}</span>
                      <span class="a11y-sr-only">{{
                        $t(country.accessibility)
                      }}</span>
                    </a>
                    <a
                      v-else-if="country.include_in_menu"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                      :aria-label="country.name + ' - ' + $t('Ecommerce store')"
                    >
                      {{ $t(country.name) }}
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <li class="d-md-flex flex-md-column">
              <button
                type="button"
                aria-controls="lang-asia"
                :aria-expanded="world === 4 ? 'true' : 'false'"
                :class="{ '-active': world === 4 }"
                class="link-light d-flex align-items-center justify-content-between d-md-none"
                @click="world = world === 4 ? 0 : 4"
              >
                {{ $t('Asia Pacific') }}
              </button>
              <p class="font-small menu_lang-subtitle -upper">
                {{ $t('Asia Pacific') }}
              </p>
              <ul id="lang-asia" class="row menu_lang-list">
                <li class="col-12 col-md-6" v-for="country in apac" :key="country.name">
                  <div class="menu_lang-element">
                    <ShopIcon
                      :class="{'hidden-icon': !(country.include_in_menu && country.is_e_com)}"
                      class="cart-icon"
                      aria-hidden="true"
                    />
                    <a
                      v-if="country.include_in_menu && country.accessibility"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                    >
                      <span aria-hidden="true">{{ $t(country.name) }}</span>
                      <span class="a11y-sr-only">{{
                        $t(country.accessibility)
                      }}</span>
                    </a>
                    <a
                      v-else-if="country.include_in_menu"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                      :aria-label="country.name + ' - ' + $t('Ecommerce store')"
                    >
                      {{ $t(country.name) }}
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <li class="d-md-flex flex-md-column">
              <button
                type="button"
                aria-controls="lang-other"
                :aria-expanded="world === 5 ? 'true' : 'false'"
                :class="{ '-active': world === 5 }"
                class="link-light d-flex align-items-center justify-content-between d-md-none"
                @click="world = world === 5 ? 0 : 5"
              >
                {{ $t('Middle East') }}
              </button>
              <p class="font-small menu_lang-subtitle -upper">
                {{ $t('Middle East') }}
              </p>
              <ul id="lang-other" class="row menu_lang-list">
                <li class="col-12" v-for="country in middleEast" :key="country.name">
                  <div class="menu_lang-element">
                    <ShopIcon
                      :class="{'hidden-icon': !(country.include_in_menu && country.is_e_com)}"
                      class="cart-icon"
                      aria-hidden="true"
                    />
                    <a
                      v-if="country.include_in_menu && country.accessibility"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                    >
                      <span aria-hidden="true">{{ $t(country.name) }}</span>
                      <span class="a11y-sr-only">{{
                        $t(country.accessibility)
                      }}</span>
                    </a>
                    <a
                      v-else-if="country.include_in_menu"
                      :class="{ active: localizedUrl === country.url }"
                      :href="clientUrl + country.url + currentRoute"
                      :aria-label="country.name + ' - ' + $t('Ecommerce store')"
                    >
                      {{ $t(country.name) }}
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <li class="international-list">
              <div
                class="int"
                v-for="country in international"
                :key="country.name"
              >
                <i
                  :class="{'hidden-icon': !(country.include_in_menu && country.is_e_com)}"
                  class="icon-cart"
                  :aria-hidden="true"
                ></i>
                <a
                  v-if="country.include_in_menu && country.accessibility"
                  :class="{ active: localizedUrl === country.url }"
                  :href="clientUrl + country.url + currentRoute"
                >
                  <span aria-hidden="true">{{ $t(country.name) }}</span>
                  <span class="a11y-sr-only">{{
                    $t(country.accessibility)
                  }}</span>
                </a>
                <a
                  v-else-if="country.include_in_menu"
                  :class="{ active: localizedUrl === country.url }"
                  :href="clientUrl + country.url + currentRoute"
                  :aria-label="country.name + ' - ' + $t('Ecommerce store')"
                >
                  {{ $t(country.name) }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import config from 'config'
import GlobeIcon from './icons/GlobeIcon.vue'
import ShopIcon from './icons/ShopIcon.vue'
import UndoIcon from './icons/UndoIcon.vue'

export default {
  props: ['currency', 'lang', 'menuOpen'],
  name: 'Lang',
  mixins: [ReadyHook],
  components: {
    GlobeIcon,
    UndoIcon,
    ShopIcon
  },
  data() {
    return {
      showLang: false,
      world: 3,
      links: [],
      focused: 0
    }
  },
  computed: {
    // views() {
    //   return config.storeViews.mapStoreUrlsFor
    //     .map(storeCode => config.storeViews[storeCode])
    //     .map(({ i18n, url }) => {
    //       const { fullCountryName, fullLanguageName, region } = i18n
    //       return {
    //         country: fullCountryName,
    //         lang: fullLanguageName,
    //         url,
    //         region
    //       }
    //     })
    //     .sort((a, b) => (a.country > b.country ? (a.lang > b.lang ? 1 : 0) : -1))
    // },
    europe() {
      return Object.values(config.storeViews)
        .filter(country => country.include_in_menu)
        .filter(
          country =>
            country.i18n &&
            country.i18n.region &&
            country.i18n.region === 'europe'
        )
        .sort(function(a, b) {
          return a.name > b.name ? 1 : -1
        })
    },
    ameriques() {
      return Object.values(config.storeViews)
        .filter(country => country.include_in_menu)
        .filter(
          country =>
            country.i18n &&
            country.i18n.region &&
            country.i18n.region === 'america'
        )
        .sort(function(a, b) {
          return a.name > b.name ? 1 : -1
        })
    },
    international() {
      return Object.values(config.storeViews)
        .filter(country => country.include_in_menu)
        .filter(
          country =>
            country.i18n &&
            country.i18n.region &&
            country.i18n.region === 'international'
        )
        .sort(function(a, b) {
          return a.name > b.name ? 1 : -1
        })
    },
    middleEast() {
      return Object.values(config.storeViews)
        .filter(country => country.include_in_menu)
        .filter(
          country =>
            country.i18n &&
            country.i18n.region &&
            country.i18n.region === 'middle_east'
        )
        .sort(function(a, b) {
          return a.name > b.name ? 1 : -1
        })
    },
    apac() {
      return Object.values(config.storeViews)
        .filter(country => country.include_in_menu)
        .filter(
          country =>
            country.i18n &&
            country.i18n.region &&
            (country.i18n.region === 'asia' ||
              country.i18n.region === 'pacific')
        )
        .sort(function(a, b) {
          return a.name > b.name ? 1 : -1
        })
    },
    currentRoute() {
      let { url } = currentStoreView()
      url = url || ''
      return this.$route.path.replace(url, '')
    },
    localizedUrl() {
      return currentStoreView().url || ''
    },
    clientUrl() {
      return config.client.url
    },
    isMobile() {
      return this.$store.state['zenith-ui'].menu.mobile
    }
  },
  watch: {
    menuOpen() {
      this.showLang = false
    },
    world() {
      this.updateSubmenuHeight()
    },
    showLang() {
      this.focused = 0
      this.$nextTick(() => {
        if (this.showLang) {
          this.links = this.$el.querySelectorAll('a')
          this.links[this.focused].focus()
        }
      })

      if (this.showLang) {
        this.$store.commit('zenith-ui/setLang', {
          open: true
        })
      } else {
        this.$store.commit('zenith-ui/setLang', {
          open: false
        })
      }
      this.updateSubmenuHeight()
    }
  },
  methods: {
    updateSubmenuHeight() {
      this.$nextTick(() => {
        if (!this.$el || !this.showLang || !this.isMobile) {
          this.$el.style.removeProperty('--lang-submenu-height')
          return
        }

        const activeButton = this.$el.querySelector('.world button[aria-expanded="true"]')
        const submenu = activeButton ? activeButton.parentElement.querySelector('.menu_lang-list') : null
        const submenuHeight = submenu ? submenu.scrollHeight : null
        if (submenuHeight) {
          this.$el.style.setProperty('--lang-submenu-height', `${submenuHeight}px`)
        } else {
          this.$el.style.removeProperty('--lang-submenu-height')
        }
      })
    },
    keydown(e) {
      if (e.keyCode === 38 && this.showLang) {
        e.preventDefault()
        this.focused =
          this.focused - 1 < 0 ? this.links.length - 1 : this.focused - 1
        this.links[this.focused].focus()
      }
      if (e.keyCode === 40 && this.showLang) {
        e.preventDefault()
        this.focused =
          this.focused + 1 >= this.links.length ? 0 : this.focused + 1
        this.links[this.focused].focus()
      }
    },
    keyup(e) {
      if (e.keyCode === 27 && this.showLang) {
        this.showLang = false
      }
    },
    trapFocus(e) {
      if (
        this.showLang &&
        !(this.$el === e.target || this.$el.contains(e.target)) &&
        (!e.target.classList || !e.target.classList.contains('lang'))
      ) {
        this.showLang = false
      }
    },
    onScroll() {
      if (window.innerWidth > 1200) {
        this.showLang = false
      }
    },
    onClick() {
      if (!this.showLang) {
        // this.$store.commit('zenith-ui/setMenu', {
        //   open: true,
        //   section: 'lang'
        // })
      }
      this.showLang = !this.showLang
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keydown)
    document.addEventListener('keyup', this.keyup)
    document.addEventListener('focus', this.trapFocus, true)
    document.addEventListener('click', this.trapFocus, true)
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    document.removeEventListener('keydown', this.keydown)
    document.removeEventListener('keyup', this.keyup)
    document.removeEventListener('focus', this.trapFocus, true)
    document.removeEventListener('click', this.trapFocus, true)
    window.addEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.lang {
  &::before {
    display: block;
    content: '';
    position: fixed;
    width: 100%;
    height: calc(100vh - var(--zenith-header-height, 9.5rem));
    top: var(--zenith-header-height, 9.5rem);
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    transition: all 0.2s ease-in-out;
    opacity: 0;
    pointer-events: none;
    left: 0;

    @include bp(max md) {
      display: none;
    }
  }

  &.-open::before {
    opacity: 1;
  }

  & > button {
    position: relative;
    border: none;
    background: none;
    font-size: 1.4rem;
    text-align: left;
    font-weight: 300;
    outline: none;
    text-transform: uppercase;
    padding: 0;
    color: var(--_zenith-header-text-link);
    transition: none;

    @include bp(max md) {
      padding-bottom: 10rem;
      width: 100%;

      /deep/ .icon {
        width: 2.4rem;
        height: 2.4rem;
      }
    }

    .link-light {
      font-size: 1.4rem;
      font-weight: 300;
      line-height: 1.2;
      color: inherit;

      &::before {
        background: var(--_zenith-header-text-link);
      }
    }

    &:hover {
      .link-light::before{
        width: 100%;
      }
    }
  }

  .menu_lang {
    position: fixed;
    z-index: 100;
    top: var(--zenith-header-height, 9.5rem);
    left: 0;
    right: 0;
    padding-block: 6rem 5rem;
    background: var(--_zenith-header-background);

    @include bp(max md) {
      top: 8.5rem;
      height: calc(100vh - 8.5rem);
      padding-block: 0 12rem;
      background: var(--_zenith-header-background);
    }

    @include bp(md xl) {
      max-height: calc(100vh - var(--zenith-header-height, 9.5rem) - 10rem);
      overflow-y: auto;
    }

    &-subtitle {
      color: var(--_zenith-header-text-link);
      margin-bottom: 4rem;

      @include bp(max md) {
        display: none;
      }
    }

    &-container {
      @include bp(xl) {
        max-width: 130rem;
        margin-inline: auto;
      }
    }

    &-title {
      font-size: 2.4rem;
      font-weight: 300;
      color: var(--_zenith-header-text-link);
      margin-bottom: 4rem;
    }

    ul {
      position: relative;
      list-style: none;

      button {
        display: block;
        text-transform: uppercase;
        background: none;
        border: none;
        width: 100%;
        padding: 0;
        text-align: left;
        color: var(--_zenith-header-text-link);

        @include bp(max md) {
          position: relative;
          margin: 0;
          padding-block: 2.5rem;
          font-weight: 300;

          &:not(.world > li:first-child button) {
            border-top: 1px solid var(--_zenith-color-transparent);
          }

          &::before {
            content: none;
          }

          &::after {
            font-family: 'zenith', sans-serif !important;
            speak: none;
            line-height: 1;
            font-size: 2.4rem;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            display: block;
            content: '\e913';
            transform: rotate(0);
            transition: all 0.2s ease-in-out;
          }

          &.-active {
            &:after {
              transform: rotate(180deg);
            }
            & ~ ul {
              opacity: 1;
              max-height: calc(var(--lang-submenu-height, 140rem) + 5rem);
              visibility: visible;
              background: rgba(255, 255, 255, 0.05);
              backdrop-filter: blur(1.75rem);
              overflow-y: auto;

              .menu_lang-element:not(li:last-child .menu_lang-element) {
                border-bottom: 0.1rem solid var(--_zenith-color-transparent);
              }
            }
          }
        }
      }

      a {
        color: var(--_zenith-header-text-link);
        position: relative;
        text-transform: uppercase;
        padding-block: 2.5rem;
        font-size: 1.6rem;
        font-weight: 300;
        line-height: 1.2;
        text-align: left;
        width: 100%;

        @include bp(md) {
          width: auto;
          padding-block: 0;
          font-size: 1.2rem;
        }
        &:after {
          display: block;
          content: '';
          position: absolute;
          bottom: 0;
          width: 0;
          height: 0.1rem;
          left: 0;
          opacity: 0;
          background: var(--_zenith-header-text-link);
          transition: all 0.2s ease-in-out;

          @include bp(max md) {
            display: none;
          }
        }

        &.active {
          font-weight: 600;
          color: var(--_zenith-header-text-link);
        }

        &:hover,
        &:active {
          color: var(--_zenith-header-text-link);
          &:after {
            width: 100%;
            opacity: 1;
          }
        }
      }
    }

    .world {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;

      @include bp(max md) {
        overflow-y: auto;
        display: block;
        height: auto;
        max-height: calc(var(--100dvh, 100vh) - 16rem);
        min-height: 15rem;
      }

      ul {
        @include bp(max md) {
          overflow: hidden;
          visibility: hidden;
          opacity: 0;
          max-height: 0;
          transition: all 0.2s ease-in-out;
        }
        li {
          .menu_lang-element {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 1rem;
            width: 100%;

            .cart-icon {
              padding: 0.6rem;
              background: rgba(255, 255, 255, 0.15);
              border-radius: 50%;
              flex-shrink: 0;
              &.hidden-icon /deep/ * {
                visibility: hidden;
              }
            }
          }
        }
      }

      & > li {
        @include bp(lg) {
          padding-inline: 2.5rem;

          &:first-child {
            padding-left: 0;
          }

          &:not(:nth-last-child(-n+2)) > ul {
            border-right: 0.1rem solid var(--zenith-white-transparent);
            height: 100%;
            align-content: flex-start;
          }
        }
        ul {
          padding-left: 0;

          &.menu_lang-list {
            @include bp(md) {
              row-gap: 1.5rem;
            }
          }
        }
        &:nth-child(2) {
          width: 33.33333334%;

          ul {
            column-count: 3;
          }
          @include bp(max xl) {
            width: 50%;
            order: 0;
          }
          @include bp(max md) {
            width: 100%;
            order: 0;

            ul {
              column-count: auto;
            }
          }
        }

        &:first-child {
          width: 16.66666667%;
          @include bp(max xl) {
            width: 50%;
            order: 2;
            margin-top: 2rem;
          }
          @include bp(max md) {
            width: 100%;
            order: 0;
          }
        }

        &:nth-child(3) {
          width: 33.33333334%;
          @include bp(max xl) {
            width: 50%;
            order: 1;
          }

          ul {
            column-count: 2;
          }

          @include bp(max md) {
            order: 0;
            width: 100%;
            padding: 0;
            margin: 0;
            border: none;

            ul {
              column-count: auto;
            }
          }
        }

        &:nth-child(4) {
          width: 16.66666667%;
          @include bp(max xl) {
            width: 50%;
            order: 3;
            margin-top: 2rem;
          }
          @include bp(max md) {
            order: 0;
            width: 100%;
          }
        }

        &:last-child {
          border-top: 1px solid var(--zenith-white-transparent);
          padding-top: 2.5rem;
          width: 100%;
          order: 5;

          ul {
            column-count: 2;
          }


          @include bp(max md) {
            ul {
              column-count: auto;
            }
          }
        }
      }

      .international-list {
        padding-left: 0;

        @include bp(lg) {
          margin-top: 4rem;
        }

        .icon-cart.hidden-icon {
          display: none;
        }
      }

      .int {
        @include bp(max md) {
          margin-bottom: 8rem;
        }
        a {
          letter-spacing: em(2, 12);
        }
      }
    }

    .back {
      position: relative;
      text-align: start;
      width: 100%;
      border: none;
      background: var(--_zenith-header-background);
      text-transform: uppercase;
      padding-block: 1.5rem;
      border-block: 1px solid var(--_zenith-color-transparent);
      color: var(--_zenith-header-text-link);
    }
  }
}
</style>
